export default __webpack_public_path__ + "static/media/coingecko.4d9bab64.png";